import { ORDER_INQUIRY_KIND_LABELS, ORDER_INQUIRY_STATUS_LABELS } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { Link } from 'react-router';
import { useOrderInquiriesByOrderQuery } from '@/entities/order-inquiry';
import { formatDateTime } from '@/shared/lib';
import { StatusBadge } from '@/shared/ui';

interface OrderDetailInquiriesProps {
  readonly orderId: string;
}

/** 주문 상세 아래 "교환·환불 문의" 카드 — 문의가 없거나 불러오는 중이면 그리지 않는다. */
export const OrderDetailInquiries = ({
  orderId,
}: OrderDetailInquiriesProps): ReactElement | null => {
  const query = useOrderInquiriesByOrderQuery(orderId);
  const items = query.data?.items ?? [];
  if (items.length === 0) return null;

  return (
    <section
      aria-label="교환·환불 문의"
      className="mt-5 rounded-2xl border border-foreground/[0.06] bg-card px-5 py-4"
    >
      <h2 className="font-medium">교환·환불 문의</h2>
      <ul className="mt-3 flex flex-col gap-2 text-sm">
        {items.map((inquiry) => (
          <li key={inquiry.id} className="flex flex-wrap items-center gap-3">
            <span>{ORDER_INQUIRY_KIND_LABELS[inquiry.kind]}</span>
            <StatusBadge tone={inquiry.status === 'OPEN' ? 'warning' : 'positive'}>
              {ORDER_INQUIRY_STATUS_LABELS[inquiry.status]}
            </StatusBadge>
            <span className="text-muted-foreground">{formatDateTime(inquiry.createdAt)}</span>
            <Link
              to={`/order-inquiries/${inquiry.id}`}
              className="underline decoration-foreground/30 underline-offset-4 hover:decoration-foreground"
            >
              상세
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
};
